export default __webpack_public_path__ + "static/media/brainone.c15e2f8c.png";